import { useApolloClient } from "@apollo/client";
import { useAppDispatch } from "../../../Store";
import { useCallback } from "react";
import {  CREATE_ANIMAL_EVENT, CreateAnimalEventResponse } from "./GQLCalls/getEvents";
import {  dispatchFetchAnimalEvent } from "./eventsSlice";


export const useEvent = (domain: string) => {
  const dispatch = useAppDispatch();
  const client = useApolloClient();


  const createEvent = useCallback(async (animalId: number, eventDefinitionId: number, timestamp: number, note: string): Promise<boolean> => {
    try {
      const response = await client.mutate<CreateAnimalEventResponse>({ mutation: CREATE_ANIMAL_EVENT, variables: { domain, animalid: animalId, eventdefinitionid: eventDefinitionId, timestamp, note } })
      const success = response.data?.animal.createEvent.success ?? false;
      if (success) {
        dispatch(dispatchFetchAnimalEvent(animalId, true))
      } 
      return success;
    } catch (error) {
      console.log("gok", error)
    }
    return false;
  }, [client, dispatch, domain])

  return {createEvent}
}

export const ANIMAL_EVENT_NOTE_ID = 1 as const;